export const OPEN_MODAL = 'MODALMANAGER.OPEN_MODAL';
export const CLOSE_MODAL = 'MODALMANAGER.CLOSE_MODAL';
export const CLOSE_MODAL_TRANSACTION = 'MODALMANAGER.CLOSE_MODAL_TRANSACTION';
export const CHANGE_MODAL_VISIBILITY = 'MODALMANAGER.CHANGE_MODAL_VISIBILITY';
export const CHANGE_MODAL_PROPS_ACTION = 'MODALMANAGER.CHANGE_MODAL_PROPS_ACTION';
export const UPDATE_MODAL_BUTTON = 'MODALMANAGER.UPDATE_MODAL_BUTTON';
export const CHANGE_MODAL_DATA = 'MODALMANAGER.CHANGE_MODAL_DATA';
export const CLOSE_VISIBLE_MODALS = 'MODALMANAGER.CLOSE_VISIBLE_MODALS';
